import { css } from '@emotion/css';
import { rgba } from 'polished';
import { computed } from 'vue';
import { useTheme } from '../../composables/theme';

export const useStyles = () => {
  const theme = useTheme();

  const baseClass = computed(() => css({
    '&, *': {
      margin: 0,
      boxSizing: 'border-box',
      cursor: 'default',
    },
    borderRadius: '0.625rem',
    padding: '0.5rem',
    borderWidth: '1px',
    borderStyle: 'solid',
    width: '25rem',
    gap: '0.5rem',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'left',
    '&--full-width': {
      width: '100%',
    },
    '&--default': {
      borderColor: theme.value.colors.gray.medium1,
      color: theme.value.colors.gray.medium1,
      background: theme.value.colors.gray.light3,
    },
    '&--default > &__text': {
      color: theme.value.colors.gray.medium1,
    },
    '&--success': {
      borderColor: theme.value.colors.success,
      color: theme.value.colors.success,
      background: rgba(theme.value.colors.success, 0.2),
    },
    '&--success > &__text': {
      color: theme.value.colors.success,
    },
    '&--in-process': {
      borderColor: theme.value.colors.inProcess,
      color: theme.value.colors.inProcess,
      background: rgba(theme.value.colors.inProcess, 0.2),
    },
    '&--in-process > &__text': {
      color: theme.value.colors.inProcessDark,
    },
    '&--warning': {
      borderColor: theme.value.colors.warning,
      color: theme.value.colors.warning,
      background: rgba(theme.value.colors.warning, 0.2),
    },
    '&--warning > &__text': {
      color: theme.value.colors.warning,
    },
    '&--error': {
      borderColor: theme.value.colors.error,
      color: theme.value.colors.error,
      background: rgba(theme.value.colors.error, 0.2),
    },
    '&--error > &__text': {
      color: theme.value.colors.error,
    },
    '&--info': {
      borderColor: theme.value.colors.info,
      color: theme.value.colors.info,
      background: rgba(theme.value.colors.info, 0.2),
    },
    '&--info > &__text': {
      color: theme.value.colors.info,
    },
    '&__icon': {
      minWidth: '1.5rem',
      width: '1.5rem',
      maxWidth: '1.5rem',
      aspectRatio: '1 / 1',
      height: 'auto',
    },
    [`@media (max-width: ${theme.value.breakpoints.desktop}px)`]: {
      alignItems: 'flex-start',

      '&__icon': {
        minWidth: '1rem',
        width: '1rem',
        maxWidth: '1rem',
      },

      '&__text': {
        fontWeight: '400',
        fontSize: '0.75rem',
        lineHeight: '1.125rem',
      },
    },
  }));
  return baseClass;
};
